import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupportTicketComponent } from './support-ticket/support-ticket.component';
import { SharedModule } from '../../shared/shared.module';
import { IconsModule } from '../../icons/icons.module';

@NgModule({
  declarations: [
    SupportTicketComponent
  ],
  exports: [
    SupportTicketComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule
  ]
})
export class TicketsModule { }
